import React, { Fragment, useEffect, useState } from "react";
import { useTranslation, useQuery } from "@1f/react-sdk";

//Vapor Components
import Stack from "@vapor/react-material/Stack";
import Box from "@vapor/react-material/Box";
import Button from "@vapor/react-material/Button";
import Modal from "@vapor/react-material/Modal";
import Divider from "@vapor/react-material/Divider";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Link from "@vapor/react-material/Link";

//Style
import { modalStyle } from "../businessLogic/styles";

//Query
import { query_releaseNotes } from "../businessLogic/query/releaseNotesQueries";

export const ModalVersion = ({ show, onClose, onOk }) => {
  const { t } = useTranslation();
  const [latestRelease, setLatestRelease] = useState(null);

  const apiGetReleaseNotes = useQuery(
    query_releaseNotes,
    {},
    { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
  );

  useEffect(() => {
    if (show) {
      loadLatestRelease();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  const loadLatestRelease = async () => {
    try {
      const releaseNotes = await apiGetReleaseNotes.fetch();
      if (releaseNotes?.data?.data?.releasenotes?.length > 0) {
        // Ordina per data e prendi l'ultima
        const sorted = [...releaseNotes.data.data.releasenotes].sort(
          (a, b) => new Date(b.Date) - new Date(a.Date)
        );
        setLatestRelease(sorted[0]);
      }
    } catch (e) {
      console.error("Error loading release notes:", e);
    }
  };

  //Actions
  const handleModalClose = (e) => {
    onClose(e);
  };
  const handleModalOk = (e) => {
    onOk(e);
  };

  return (
    <Fragment>
      <Modal
        key="confirmSaveModal"
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        open={show}
        onClose={handleModalClose}
        onBackdropClick={handleModalClose}
      >
        <Box sx={modalStyle}>
          <Stack
            direction="column"
            spacing={0}
            justifyContent="left"
            alignItems="left"
          >
            <ExtendedTypography
              variant="titleSmall"
              color="primary.main"
              sx={{ p: 2, pl: 3 }}
            >
              L'applicazione è stata aggiornata
            </ExtendedTypography>
            <Divider orientation="horizontal" flexItem />
            <ExtendedTypography variant="subtitle2" sx={{ p: 2, pl: 3, pt: 3 }}>
              L'applicazione è stata aggiornata, per scoprire le novità ti
              invitiamo a leggere le note di release qui sotto:
            </ExtendedTypography>
            {latestRelease && latestRelease.Pdf && (
              <Box sx={{ pb:1, pl: 3 }}>
                <Link
                  href={`/releaseNotes/${latestRelease.Pdf}`}
                  download={latestRelease.Pdf}
                  underline="hover"
                  sx={{ cursor: "pointer" }}
                >
                  📥 Scarica il manuale di versione {latestRelease.Version}
                </Link>
              </Box>
            )}
          </Stack>
          <Stack
            direction="row"
            spacing={1}
            sx={{ p: 1, mt: 1, bgcolor: "#F2F5F8" }}
            justifyContent="right"
            alignItems="right"
          >
            <Button variant="outlined" size="small" onClick={handleModalClose}>
              {t("actions.annulla")}
            </Button>
            <Button variant="contained" size="small" onClick={handleModalOk}>
              Non visualizzare più questo messaggio
            </Button>
          </Stack>
        </Box>
      </Modal>
    </Fragment>
  );
};
